
import { Component, Vue, Watch } from 'vue-property-decorator'
import Channel from '@/components/channels/Channel.vue'
import GuestCookie from '@/components/guest-cookie'
import Squircle from '@/components/V3/Squircle.vue'

@Component({
  components: {
    Channel,
    Squircle
  }
})
export default class Wrapper extends Vue {
  private chatboxHeight = 480
  private height: number | null = null
  private maxHeight: number | null = null
  private mobileWidth = 640
  private windowWidth = window.innerWidth

  private params = {
    httpUrl: process.env.VUE_APP_BACKEND_URL,
    uploadUrl: process.env.VUE_APP_UPLOAD_URL,
    uploadSize: parseInt(process.env.VUE_APP_UPLOAD_MAX_SIZE, 10),
    windowUrl: process.env.VUE_APP_WINDOW_URL,
    wsUrl: process.env.VUE_APP_BACKEND_WS
  }

  private channelsOrder = [
    'whatsapp',
    'messenger',
    'abc',
    'googlebm',
    'telegram',
    'web_chat'
  ]

  get CTA (): string {
    return this.$store.getters.cta
  }

  get channels (): Array<any> {
    const channels = (this.$store.getters.channels || []).concat([])
    const order = this.channelsOrder

    return channels.sort((a: Record<string, unknown>, b: Record<string, unknown>) => {
      return order.indexOf(a.name as string) > order.indexOf(b.name as string)
            ? 1
            : -1
    })
  }

  get isWidgetColorLight (): boolean {
    return this.$store.getters.isWidgetColorLight
  }

  get style (): string {
    const isChatboxView = this.$store.getters['webchat/step'] === 'chatbox'
    const isMobile = this.windowWidth <= this.mobileWidth
    const minHeight = isChatboxView && !isMobile ? this.chatboxHeight : (this.height || 0)
    return `background-color: ${this.widgetColor};
            max-height: ${!isMobile ? this.maxHeight + 'px' : 'none'};
            min-height: ${Math.min(minHeight, this.maxHeight || minHeight)}px`
  }

  get widgetAgents (): string {
    return this.$store.getters.widgetAgents
  }

  get widgetColor (): string {
    return this.$store.getters.widgetColor
  }

  get widgetState (): string {
    return this.$store.getters.state
  }

  get widgetSubtitle (): string {
    return this.$store.getters.widgetSubtitle
  }

  get widgetTitle (): string {
    return this.$store.getters.widgetTitle
  }

  created (): void {
    window.addEventListener('resize', this.updateSize)
  }

  destroyed (): void {
    window.removeEventListener('resize', this.updateSize)
  }

  toggle (): void {
    GuestCookie.storeGuest('close', this.$store.getters.account, 'on')
    this.$store.commit('setState', 'hidden')
  }

  updateSize (_e: Event | null, animationDelay?: number) {
    window.requestAnimationFrame(() => {
      this.$nextTick(() => {
        const el = this.$el as HTMLElement
        if (['chatbox', 'shown'].includes(this.widgetState) &&
          this.height === null && window.innerWidth > this.mobileWidth) {
          this.height = el.offsetHeight
        }
        this.windowWidth = window.innerWidth

        setTimeout(() => {
          this.maxHeight = this.$el && el.getBoundingClientRect
            ? el.getBoundingClientRect().bottom
            : window.innerHeight
        }, animationDelay || 0)
      })
    })
  }

  @Watch('widgetState')
  watchWidgetState () {
    this.updateSize(null, 250)
  }
}
